const types = {
    flat: 'Appartement',
    duplex_apartment: 'Appartement Duplex',
    house: 'Maison',
    duplex_house: "Maison Duplex",
    bedroom: 'Chambre',
    building: 'Immeuble',
    pro_local: 'Local pro',
    studio: 'Studio',
    land_house: 'Terrain',
    box: 'Box',
    parking_handi: 'Parking Handicapé',
    parking_standard: 'Parking',
    other: 'Autre'

};

const types2 = {
    T1: 'T1',
    T2: 'T2',
    T3: 'T3',
    T4: 'T4',
    T5: 'T5',
    T6: 'T6',
    T7: 'T7',
    NC: 'NC',
    'Local Commercial': 'Local Commercial',
    'Box':'Box'
};



const exposures = {
    N: 'Nord',
    NE: 'Nord-Est',
    E: 'Est',
    SE: 'Sud-Est',
    S: 'Sud',
    SO: 'Sud-Ouest',
    O: 'Ouest',
    NO: 'Nord-Ouest',
    NC:'NC'
  };

  const exposuresArr = Object.keys(exposures).map(key => ({
    text: (exposures as any)[key],
    value: key,
}));


  

const typesArr = Object.keys(types).map(key => ({
    text: (types as any)[key],
    value: key,
}));

const types2Arr = Object.keys(types2).map(key => ({
    text: (types2 as any)[key],
    value: key,
}));

function formatType(value: string) {
    // @ts-ignore
    return value in types ? types[value] : value;
}

function formatType2(value: string) {
    // @ts-ignore
    return value in types2 ? types2[value] : value;
}






export { types, types2, typesArr, exposures, exposuresArr,  types2Arr, formatType, formatType2  };
